import React from 'react'
import { SortingInterface } from '../../../hooks/useSorting'
import type { Column } from '../.'
import { HeaderCell } from '../styles'
import { IconComponent } from '~/assets/icons/component'

interface HeaderItemProps extends Column {
  columnKey: string
  sorting?: SortingInterface<string>
  itemsCount: number
}

export const HeaderItem = ({ columnKey, width, minWidth, sorting, sortable, itemsCount, label }: HeaderItemProps) => {
  let sortIcon: React.ReactElement | null = null

  if (sortable && sorting) {
    if (sorting.selectedColumn !== columnKey) {
      // sortable column
      sortIcon = <IconComponent name="chevronUpDown" iconsize={10} />
    } else if (sorting.selectedColumn === columnKey && sorting.isDesc) {
      // sortable column descending
      sortIcon = <IconComponent name="chevronDown" iconsize={10} />
    } else if (sorting.selectedColumn === columnKey && !sorting.isDesc) {
      // sortable column ascending
      sortIcon = <IconComponent name="chevronUp" iconsize={10} />
    }
  }

  return (
    <HeaderCell
      width={width}
      minWidth={minWidth}
      length={itemsCount}
      clickable={sortable}
      onClick={() => {
        if (sorting) sorting.onSorting(columnKey)
      }}
    >
      <span>{label}</span>
      {sortIcon}
    </HeaderCell>
  )
}
